import { ref, computed } from 'vue'
import { fetchSupportUnreadCount } from '@/api/support'

// Module-level singleton ref so the count is shared across all consumers
// (navbar, thread page) without a global store. Same pattern as useCreditBalance.
const count = ref(0)
const loading = ref(false)

export function useSupportUnreadCount() {
  const hasUnread = computed(() => count.value > 0)

  async function fetch(organisationId: number): Promise<void> {
    if (!organisationId) return
    loading.value = true
    try {
      const result = await fetchSupportUnreadCount(organisationId)
      count.value = result.count
    } catch {
      // Silent failure — dot disappears, which is a safe degraded state
      count.value = 0
    } finally {
      loading.value = false
    }
  }

  return { count, hasUnread, loading, fetch }
}
